let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfYwm")).then(() => parcelRequire('3rNQG'));